<template>
  <section
      v-if="products.length > 0"
      class="discount-catalog"
  >
    <div class="page__top discount-catalog__top">
      <h2 class="title">Товары, которые могут вам пригодиться:</h2>
      <div class="page__top-buttons discount-catalog__buttons">
        <div
            class="page__top-arrows discount-catalog__arrows"
            v-if="!$isMobile()"
        >
          <button
              class="discount-catalog__prev"
              @click="prevSlide"
          >
            <img
                src="@/assets/img/icons/prev-arrow-white.svg"
                alt=""
            />
          </button>
          <button
              class="discount-catalog__next"
              @click="nextSlide"
          >
            <img
                src="@/assets/img/icons/next-arrow-white.svg"
                alt=""
            />
          </button>
        </div>
      </div>
    </div>
    <div
        class="discount-catalog__slider"
        v-if="!$isMobile()"
    >
      <swiper
          ref="swiperRef"
          :options="swiperOption"
          :key="swiperOption.loop"
      >
        <swiper-slide
            v-for="item in products"
            :key="item.id"
        >
          <product-card :item="item"/>
        </swiper-slide>
      </swiper>
    </div>
    <div
        class="discount-catalog__mobile"
        v-else
    >
      <div
          class="discount-catalog__mobile-list"
          v-for="(item, index) in products"
          :key="item.id"
      >
        <product-card
            v-if="index < 5"
            :item="item"
        />
      </div>
      <!-- <products-list v-if="products" :items="products" /> -->
    </div>
  </section>
</template>

<script>
export default {
  name: "DiscountList",
  components: {
    // ProductsList: () => import("@/components/products/ProductsList.vue"),
    ProductCard: () => import("@/components/products/ProductCard.vue"),
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      swiperOption: {
        lazy: true,
        slideTo: 1,
        slidesPerView: 1,
        loop: false,
        // spaceBetween: ,
        initialSlide: 1,
        centeredSlides: false,
        responsive: true,
        breakpoints: {
          600: {
            slidesPerView: 2,
          },
          800: {
            slidesPerView: 3,
          },
          1000: {
            slidesPerView: 4,
          },
          // 1200:{
          //   slidesPerView:
          // }
        },
      },
    }
  },
  computed: {
    swiper() {
      return this.$refs?.swiperRef
    },
  },
  methods: {
    prevSlide() {
      this.swiper?.swiperInstance.slidePrev()
    },
    nextSlide() {
      this.swiper.swiperInstance.slideNext()
    },
  },
  mounted() {
    if (this.products.length > 4) {
      this.swiperOption.loop = true
    } else {
      this.swiperOption.loop = false
    }
  },
}
</script>
<style
    lang="scss"
    scoped
>
.title {
  font-size: 38px;
  line-height: 110%;
  font-family: "CeraPro Bold";
  color: #2d2f32;
}

.discount-catalog__mobile-list {
  margin-right: 10px;
}

@media (max-width: 768px) {
  .title {
    font-size: 20px;
    /* max-width: 140px; */
  }
  .product-block__descr {
    font-size: 14px;
  }
}
</style>
